import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-primary-500 via-primary-500 to-accent-500 p-8 md:p-12 text-center">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full -translate-y-1/2 translate-x-1/2"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-white rounded-full translate-y-1/2 -translate-x-1/2"></div>
          </div>
          <div className="relative z-10">
            <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
              {t('home.cta_title')}
            </h2>
            <p className="text-sm text-background-50/80 mb-6 max-w-md mx-auto">
              {t('home.cta_subtitle')}
            </p>
            <Link
              to="/category/rexue"
              className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 text-primary-500 rounded-full font-semibold text-sm hover:bg-background-50/90 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line text-lg"></i>
              {t('home.cta_button')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}